module.exports = __webpack_public_path__ + "img/logo_abc.9fb59167.png";